import { useEffect } from "react";

/**
 * Force the `<html>` element to the LIGHT theme while a public (customer-
 * facing) page is mounted, restoring the admin's preferred theme on unmount.
 *
 * Customer-facing pages (PublicBookingPage, PublicQuotePage,
 * PublicTermsPage, EmbedLeadFormPage) are always designed on a clean
 * light surface so the customer gets a bright, trustworthy, invoice-
 * like experience regardless of what theme the shop admin prefers in
 * their internal console.
 */
export default function useForceLightTheme() {
  useEffect(() => {
    const htmlEl = document.documentElement;
    const prevHtmlClasses = htmlEl.className;
    const wasDark = htmlEl.classList.contains("dark");
    htmlEl.classList.remove("dark");
    htmlEl.classList.add("light");
    return () => {
      htmlEl.className = prevHtmlClasses;
      if (wasDark) {
        htmlEl.classList.add("dark");
        htmlEl.classList.remove("light");
      }
    };
  }, []);
}
